import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter, map, tap } from 'rxjs';

import BetslipPickActions from '../../picks/actions';
import { QuickBetActions } from '../quick-bet-actions';
import { selectQuickBetDisplayHelper } from '../quick-bet.selectors';
import { QuickBetService } from '../services/quick-bet.service';

@Injectable()
export class QuickBetUndoEffects {
    constructor(
        private actions$: Actions,
        private store: Store,
        private quickBetService: QuickBetService,
    ) {}

    handleQuickBetReopenOnUndo$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipPickActions.removeLastPickError),
            concatLatestFrom(() => [this.store.select(selectQuickBetDisplayHelper)]),
            filter(([, displayHelper]) => displayHelper.hiddenByError),
            tap(() => {
                this.quickBetService.toggleQuickBetVisibility(true);
            }),
            map(() => QuickBetActions.setHiddenByError({ isHidden: false })),
        );
    });
}
